// Removed stray/duplicate getEarliestProjectDate. Only keep the method inside the class body below.
import {
  CandidateProfile,
  CvGenerationRequest,
  CvGenerationResponse,
  FocusArea,
} from '../../services/cvGenerator';
import {
  CandidateProfileDto,
  FocusAreasResponseDto,
  GenerateCvResponseDto,
} from './cvApiDtos';
import {
  mapCandidateProfileDtoToDomain,
  mapFocusAreasResponseDtoToDomain,
  mapGenerateCvRequestToDto,
  mapGenerateCvResponseDtoToDomain,
} from './cvApiMappers';
import { ApiLanguage, CvDataCollection } from './cvDataCollection';

export class RealApiCvDataCollection implements CvDataCollection {
  private readonly baseUrl: string;

  constructor(baseUrl = '/api/v1') {
    this.baseUrl = baseUrl.replace(/\/$/, '');
  }

  async getCandidateProfile(language: ApiLanguage): Promise<CandidateProfile> {
    const dto = await this.fetchJson<CandidateProfileDto>(
      `${this.baseUrl}/candidate-profile?lang=${language}`,
      {
        method: 'GET',
      }
    );

    return mapCandidateProfileDtoToDomain(dto);
  }

  async getAvailableFocusAreas(language: ApiLanguage): Promise<FocusArea[]> {
    const dto = await this.fetchJson<FocusAreasResponseDto>(
      `${this.baseUrl}/focus-areas?lang=${language}`,
      {
        method: 'GET',
      }
    );

    return mapFocusAreasResponseDtoToDomain(dto);
  }

  async getAvailableTechnologies(language: ApiLanguage): Promise<string[]> {
    const dto = await this.fetchJson<string[]>(
      `${this.baseUrl}/technologies?lang=${language}`,
      {
        method: 'GET',
      }
    );

    return dto;
  }

  async generateCv(
    request: CvGenerationRequest,
    language: ApiLanguage
  ): Promise<CvGenerationResponse> {
    const requestDto = mapGenerateCvRequestToDto(request);
    const responseDto = await this.fetchJson<GenerateCvResponseDto>(
      `${this.baseUrl}/cv/generate?lang=${language}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestDto),
      },
    );

    return mapGenerateCvResponseDtoToDomain(responseDto);
  }

  private async fetchJson<T>(
    url: string,
    init: RequestInit
  ): Promise<T> {
    const response = await fetch(url, {
      ...init,
      headers: {
        Accept: 'application/json',
        ...(init.headers || {}),
      },
    });

    if (!response.ok) {
      throw new Error(`API request failed (${response.status}) for ${url}`);
    }

    return (await response.json()) as T;
  }
  async getEarliestProjectDate(language: ApiLanguage): Promise<string> {
    // This should call the real API for projects, but for now fallback to placeholder logic
    // (or implement if your API supports it)
    // Example fallback:
    const date = new Date();
    date.setFullYear(date.getFullYear() - 3);
    return date.toISOString().slice(0, 10);
  }
}
